const countryList = {
  AED: { name: "United Arab Emirates", flag: "🇦🇪", currencysymbol: "د.إ" },
  AFN: { name: "Afghanistan", flag: "🇦🇫", currencysymbol: "؋" },
  ALL: { name: "Albania", flag: "🇦🇱", currencysymbol: "L" },
  AMD: { name: "Armenia", flag: "🇦🇲", currencysymbol: "֏" },
  ANG: { name: "Netherlands Antilles", flag: "🇳🇱", currencysymbol: "ƒ" },
  AOA: { name: "Angola", flag: "🇦🇴", currencysymbol: "Kz" },
  ARS: { name: "Argentina", flag: "🇦🇷", currencysymbol: "$" },
  AUD: { name: "Australia", flag: "🇦🇺", currencysymbol: "A$" },
  AWG: { name: "Aruba", flag: "🇦🇼", currencysymbol: "ƒ" },
  AZN: { name: "Azerbaijan", flag: "🇦🇿", currencysymbol: "₼" },
  BAM: { name: "Bosnia and Herzegovina", flag: "🇧🇦", currencysymbol: "KM" },
  BBD: { name: "Barbados", flag: "🇧🇧", currencysymbol: "Bds$" },
  BDT: { name: "Bangladesh", flag: "🇧🇩", currencysymbol: "৳" },
  BGN: { name: "Bulgaria", flag: "🇧🇬", currencysymbol: "лв" },
  BHD: { name: "Bahrain", flag: "🇧🇭", currencysymbol: ".د.ب" },
  BIF: { name: "Burundi", flag: "🇧🇮", currencysymbol: "FBu" },
  BMD: { name: "Bermuda", flag: "🇧🇲", currencysymbol: "BD$" },
  BND: { name: "Brunei", flag: "🇧🇳", currencysymbol: "B$" },
  BOB: { name: "Bolivia", flag: "🇧🇴", currencysymbol: "Bs" },
  BRL: { name: "Brazil", flag: "🇧🇷", currencysymbol: "R$" },
  BSD: { name: "Bahamas", flag: "🇧🇸", currencysymbol: "B$" },
  BTN: { name: "Bhutan", flag: "🇧🇹", currencysymbol: "Nu." },
  BWP: { name: "Botswana", flag: "🇧🇼", currencysymbol: "P" },
  BYN: { name: "Belarus", flag: "🇧🇾", currencysymbol: "Br" },
  BZD: { name: "Belize", flag: "🇧🇿", currencysymbol: "BZ$" },
  CAD: { name: "Canada", flag: "🇨🇦", currencysymbol: "C$" },
  CDF: {
    name: "Democratic Republic of the Congo",
    flag: "🇨🇩",
    currencysymbol: "FC",
  },
  CHF: { name: "Switzerland", flag: "🇨🇭", currencysymbol: "CHF" },
  CLP: { name: "Chile", flag: "🇨🇱", currencysymbol: "$" },
  CNY: { name: "China", flag: "🇨🇳", currencysymbol: "¥" },
  COP: { name: "Colombia", flag: "🇨🇴", currencysymbol: "$" },
  CRC: { name: "Costa Rica", flag: "🇨🇷", currencysymbol: "₡" },
  CUP: { name: "Cuba", flag: "🇨🇺", currencysymbol: "$" },
  CVE: { name: "Cape Verde", flag: "🇨🇻", currencysymbol: "$" },
  CZK: { name: "Czech Republic", flag: "🇨🇿", currencysymbol: "Kč" },
  DJF: { name: "Djibouti", flag: "🇩🇯", currencysymbol: "Fdj" },
  DKK: { name: "Denmark", flag: "🇩🇰", currencysymbol: "kr" },
  DOP: { name: "Dominican Republic", flag: "🇩🇴", currencysymbol: "RD$" },
  DZD: { name: "Algeria", flag: "🇩🇿", currencysymbol: "د.ج" },
  EGP: { name: "Egypt", flag: "🇪🇬", currencysymbol: "£" },
  ERN: { name: "Eritrea", flag: "🇪🇷", currencysymbol: "Nfk" },
  ETB: { name: "Ethiopia", flag: "🇪🇹", currencysymbol: "Br" },
  EUR: { name: "Eurozone", flag: "🇪🇺", currencysymbol: "€" },
  FJD: { name: "Fiji", flag: "🇫🇯", currencysymbol: "FJ$" },
  GBP: { name: "United Kingdom", flag: "🇬🇧", currencysymbol: "£" },
  GHS: { name: "Ghana", flag: "🇬🇭", currencysymbol: "GH₵" },
  GIP: { name: "Gibraltar", flag: "🇬🇮", currencysymbol: "£" },
  GMD: { name: "Gambia", flag: "🇬🇲", currencysymbol: "D" },
  GNF: { name: "Guinea", flag: "🇬🇳", currencysymbol: "FG" },
  GTQ: { name: "Guatemala", flag: "🇬🇹", currencysymbol: "Q" },
  HKD: { name: "Hong Kong", flag: "🇭🇰", currencysymbol: "HK$" },
  HNL: { name: "Honduras", flag: "🇭🇳", currencysymbol: "L" },
  HRK: { name: "Croatia", flag: "🇭🇷", currencysymbol: "kn" },
  HUF: { name: "Hungary", flag: "🇭🇺", currencysymbol: "Ft" },
  IDR: { name: "Indonesia", flag: "🇮🇩", currencysymbol: "Rp" },
  ILS: { name: "Israel", flag: "🇮🇱", currencysymbol: "₪" },
  INR: { name: "India", flag: "🇮🇳", currencysymbol: "₹" },
  IQD: { name: "Iraq", flag: "🇮🇶", currencysymbol: "ع.د" },
  IRR: { name: "Iran", flag: "🇮🇷", currencysymbol: "﷼" },
  ISK: { name: "Iceland", flag: "🇮🇸", currencysymbol: "kr" },
  JPY: { name: "Japan", flag: "🇯🇵", currencysymbol: "¥" },
  KRW: { name: "South Korea", flag: "🇰🇷", currencysymbol: "₩" },
  MYR: { name: "Malaysia", flag: "🇲🇾", currencysymbol: "RM" },
  NZD: { name: "New Zealand", flag: "🇳🇿", currencysymbol: "NZ$" },
  PHP: { name: "Philippines", flag: "🇵🇭", currencysymbol: "₱" },
  SGD: { name: "Singapore", flag: "🇸🇬", currencysymbol: "S$" },
  THB: { name: "Thailand", flag: "🇹🇭", currencysymbol: "฿" },
  USD: { name: "United States", flag: "🇺🇸", currencysymbol: "$" },
  VND: { name: "Vietnam", flag: "🇻🇳", currencysymbol: "₫" },
  ZAR: { name: "South Africa", flag: "🇿🇦", currencysymbol: "R" },
  FKP: { name: "Falkland Islands", flag: "🇫🇰", currencysymbol: "£" },
  FOK: { name: "Faroe Islands", flag: "🇫🇴", currencysymbol: "kr" },
  GEL: { name: "Georgia", flag: "🇬🇪", currencysymbol: "₾" },
  GGP: { name: "Guernsey", flag: "🇬🇬", currencysymbol: "£" },
  HTG: { name: "Haiti", flag: "🇭🇹", currencysymbol: "G" },
  IMP: { name: "Isle of Man", flag: "🇮🇲", currencysymbol: "£" },
  JEP: { name: "Jersey", flag: "🇯🇪", currencysymbol: "£" },
  JMD: { name: "Jamaica", flag: "🇯🇲", currencysymbol: "J$" },
  JOD: { name: "Jordan", flag: "🇯🇴", currencysymbol: "د.ا" },
  KES: { name: "Kenya", flag: "🇰🇪", currencysymbol: "KSh" },
  KGS: { name: "Kyrgyzstan", flag: "🇰🇬", currencysymbol: "с" },
  KHR: { name: "Cambodia", flag: "🇰🇭", currencysymbol: "៛" },
  KID: { name: "Kiribati (obsolete code)", flag: "🇰🇮", currencysymbol: "$" },
  KMF: { name: "Comoros", flag: "🇰🇲", currencysymbol: "CF" },
  KWD: { name: "Kuwait", flag: "🇰🇼", currencysymbol: "د.ك" },
  KYD: { name: "Cayman Islands", flag: "🇰🇾", currencysymbol: "CI$" },
  KZT: { name: "Kazakhstan", flag: "🇰🇿", currencysymbol: "₸" },
  LAK: { name: "Laos", flag: "🇱🇦", currencysymbol: "₭" },
  LBP: { name: "Lebanon", flag: "🇱🇧", currencysymbol: "ل.ل" },
  LKR: { name: "Sri Lanka", flag: "🇱🇰", currencysymbol: "Rs" },
  LRD: { name: "Liberia", flag: "🇱🇷", currencysymbol: "L$" },
  LSL: { name: "Lesotho", flag: "🇱🇸", currencysymbol: "L" },
  LYD: { name: "Libya", flag: "🇱🇾", currencysymbol: "ل.د" },
  MAD: { name: "Morocco", flag: "🇲🇦", currencysymbol: "د.م." },
  MDL: { name: "Moldova", flag: "🇲🇩", currencysymbol: "L" },
  MGA: { name: "Madagascar", flag: "🇲🇬", currencysymbol: "Ar" },
  MKD: { name: "North Macedonia", flag: "🇲🇰", currencysymbol: "ден" },
  MMK: { name: "Myanmar", flag: "🇲🇲", currencysymbol: "K" },
  MNT: { name: "Mongolia", flag: "🇲🇳", currencysymbol: "₮" },
  MOP: { name: "Macau", flag: "🇲🇴", currencysymbol: "MOP$" },
  MRU: { name: "Mauritania", flag: "🇲🇷", currencysymbol: "UM" },
  MUR: { name: "Mauritius", flag: "🇲🇺", currencysymbol: "₨" },
  MVR: { name: "Maldives", flag: "🇲🇻", currencysymbol: "Rf" },
  MWK: { name: "Malawi", flag: "🇲🇼", currencysymbol: "MK" },
  MXN: { name: "Mexico", flag: "🇲🇽", currencysymbol: "Mex$" },
  MZN: { name: "Mozambique", flag: "🇲🇿", currencysymbol: "MT" },
  NAD: { name: "Namibia", flag: "🇳🇦", currencysymbol: "N$" },
  NGN: { name: "Nigeria", flag: "🇳🇬", currencysymbol: "₦" },
  NIO: { name: "Nicaragua", flag: "🇳🇮", currencysymbol: "C$" },
  NOK: { name: "Norway", flag: "🇳🇴", currencysymbol: "kr" },
  NPR: { name: "Nepal", flag: "🇳🇵", currencysymbol: "₨" },
  OMR: { name: "Oman", flag: "🇴🇲", currencysymbol: "ر.ع." },
  PAB: { name: "Panama", flag: "🇵🇦", currencysymbol: "B/." },
  PEN: { name: "Peru", flag: "🇵🇪", currencysymbol: "S/." },
  PGK: { name: "Papua New Guinea", flag: "🇵🇬", currencysymbol: "K" },
  PKR: { name: "Pakistan", flag: "🇵🇰", currencysymbol: "₨" },
  PLN: { name: "Poland", flag: "🇵🇱", currencysymbol: "zł" },
  PYG: { name: "Paraguay", flag: "🇵🇾", currencysymbol: "₲" },
  QAR: { name: "Qatar", flag: "🇶🇦", currencysymbol: "ر.ق" },
  RON: { name: "Romania", flag: "🇷🇴", currencysymbol: "lei" },
  RSD: { name: "Serbia", flag: "🇷🇸", currencysymbol: "дин." },
  RUB: { name: "Russia", flag: "🇷🇺", currencysymbol: "₽" },
  RWF: { name: "Rwanda", flag: "🇷🇼", currencysymbol: "FRw" },
  SAR: { name: "Saudi Arabia", flag: "🇸🇦", currencysymbol: "ر.س" },
  SBD: { name: "Solomon Islands", flag: "🇸🇧", currencysymbol: "SI$" },
  SCR: { name: "Seychelles", flag: "🇸🇨", currencysymbol: "₨" },
  SDG: { name: "Sudan", flag: "🇸🇩", currencysymbol: "ج.س." },
  SEK: { name: "Sweden", flag: "🇸🇪", currencysymbol: "kr" },
  SHP: { name: "Saint Helena", flag: "🇸🇭", currencysymbol: "£" },
  SLE: { name: "Sierra Leone (new)", flag: "🇸🇱", currencysymbol: "Le" },
  SLL: { name: "Sierra Leone (old)", flag: "🇸🇱", currencysymbol: "Le" },
  SOS: { name: "Somalia", flag: "🇸🇴", currencysymbol: "Sh.So." },
  SRD: { name: "Suriname", flag: "🇸🇷", currencysymbol: "$" },
  SSP: { name: "South Sudan", flag: "🇸🇸", currencysymbol: "£" },
  STN: { name: "São Tomé and Príncipe", flag: "🇸🇹", currencysymbol: "Db" },
  SYP: { name: "Syria", flag: "🇸🇾", currencysymbol: "£" },
  SZL: { name: "Swaziland", flag: "🇸🇿", currencysymbol: "E" },
  TJS: { name: "Tajikistan", flag: "🇹🇯", currencysymbol: "TJS" },
  TMT: { name: "Turkmenistan", flag: "🇹🇲", currencysymbol: "TMT" },
  TND: { name: "Tunisia", flag: "🇹🇳", currencysymbol: "د.ت" },
  TOP: { name: "Tonga", flag: "🇹🇴", currencysymbol: "T$" },
  TRY: { name: "Turkey", flag: "🇹🇷", currencysymbol: "₺" },
  TTD: { name: "Trinidad and Tobago", flag: "🇹🇹", currencysymbol: "TT$" },
  TVD: { name: "Tuvalu", flag: "🇹🇻", currencysymbol: "$" },
  TWD: { name: "Taiwan (region)", flag: "🇹🇼", currencysymbol: "NT$" },
  TZS: { name: "Tanzania", flag: "🇹🇿", currencysymbol: "Sh" },
  UAH: { name: "Ukraine", flag: "🇺🇦", currencysymbol: "₴" },
  UGX: { name: "Uganda", flag: "🇺🇬", currencysymbol: "USh" },
  UYU: { name: "Uruguay", flag: "🇺🇾", currencysymbol: "$U" },
  UZS: { name: "Uzbekistan", flag: "🇺🇿", currencysymbol: "лв" },
  VES: { name: "Venezuela", flag: "🇻🇪", currencysymbol: "Bs" },
  VUV: { name: "Vanuatu", flag: "🇻🇺", currencysymbol: "VT" },
  WST: { name: "Samoa", flag: "🇼🇸", currencysymbol: "T" },
  XAF: { name: "CFA Franc BEAC", flag: "🇫🇷", currencysymbol: "FCFA" },
  XCD: { name: "East Caribbean", flag: "🇨🇩", currencysymbol: "EC$" },
  XDR: {
    name: "SDR (Special Drawing Rights)",
    flag: "🇸🇬",
    currencysymbol: "SDR",
  },
  XOF: { name: "CFA Franc BCEAO", flag: "🇫🇷", currencysymbol: "CFA" },
  XPF: { name: "French Pacific", flag: "🇵🇫", currencysymbol: "CFPF" },
  YER: { name: "Yemen", flag: "🇾🇪", currencysymbol: "﷼" },
  ZMW: { name: "Zambia", flag: "🇿🇲", currencysymbol: "ZK" },
  ZWL: { name: "Zimbabwe", flag: "🇿🇼", currencysymbol: "Z$" },
  GYD: { name: "Guyana", flag: "🇬🇾", currencysymbol: "GY$" },
  XCG: { name: "Central African", flag: "🇨🇬", currencysymbol: "FCFA" },
};

export default countryList;
